import { Button, Text } from '@cinesend/ui-kit'
import { useQuery } from '@tanstack/react-query'
import { useNavigate, useParams } from 'react-router-dom'
import useStore from '../../hooks/use_store'
import useUtilities from '../../hooks/use_utilities'
import useScrollToAnchor from '../../hooks/use_scroll_to_anchor'
import SettingsCard from '../settings_card'
import Availability from './availability'
import CategoriesCard from './categories_card'
import GlobalMetadata from './global_metadata'
import ImageFields from './image_fields'
import LocalizableMetadata from './localizable_metadata'
import MediaFields from './media_fields'
import PrerollCard from './preroll_card'

const Details = ({ asset, airlineID, cycleID, listPath }) => {
  useScrollToAnchor()
  const navigate = useNavigate()
  const { parentAssetID } = useParams()
  const { deleteModel } = useStore()
  const { assetTypes } = useUtilities()
  const { data: airline } = useQuery([`airlines/${airlineID}`])
  const assetType = assetTypes?.find((opt) => opt.value === asset?.asset_type)
  const parentAssetType = assetTypes?.find((opt) => opt.value === asset?.parent_asset_type)
  const noun = assetType?.label?.toLowerCase() || 'asset'
  const langID = airline?.languages?.[0]?.id

  const deleteAsset = () => {
    deleteModel.mutate(
      {
        endpoint: `cycles/${cycleID}/assets`,
        id: asset.id,
        deleteNoun: noun,
        deleteName: asset.default_title ?? asset.title,
      },
      {
        onSuccess: () => {
          if (parentAssetID && parentAssetType) {
            navigate(
              `/airlines/${airlineID}/cycles/${cycleID}/metadata/${parentAssetType.route_value}/${parentAssetID}`
            )
            return
          }
          if (listPath) {
            navigate(listPath)
            return
          }
          navigate(`/airlines/${airlineID}/cycles/${cycleID}/metadata/${assetType?.route_value}`)
        },
      }
    )
  }

  return (
    <div className='flex w-full flex-col gap-12'>
      <Availability asset={asset} cycleID={cycleID} />
      <CategoriesCard asset={asset} cycleID={cycleID} langID={langID} />
      <PrerollCard asset={asset} cycleID={cycleID} langID={langID} />
      <GlobalMetadata asset={asset} cycleID={cycleID} />
      <LocalizableMetadata asset={asset} airlineID={airlineID} cycleID={cycleID} />
      <MediaFields asset={asset} cycleID={cycleID} />
      <ImageFields asset={asset} cycleID={cycleID} />
      <SettingsCard title='Danger zone' description='Permanent actions that cannot be undone.'>
        <div className='flex items-center justify-between gap-6'>
          <div className='min-w-0 flex-1'>
            <Text variant='sm-medium'>Delete this {noun}</Text>
            <Text as='p' variant='sm' tone='secondary' className='mt-1'>
              Permanently delete this {noun}. This can’t be undone.
            </Text>
          </div>
          <Button variant='destructive' onClick={deleteAsset}>
            Delete
          </Button>
        </div>
      </SettingsCard>
    </div>
  )
}

export default Details
